import { MutationTree } from 'vuex';
import { initialState as resetState, NFCState } from '@/modules/Administrative/store/state';
import { NFC } from '@/modules/Administrative/store/mutation-types';
import { NFCInformations } from '@/models/NFCInformations';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { Site } from '@/models/Site';
import { NFCHistorique } from '@/models/NFCHistorique';


export const mutations: MutationTree<NFCState> = {
    [NFC.SET_ITEMS](state: NFCState, items: NFCInformations[]) {
        state.NFC = items;
    },
    [NFC.ADD_ITEMS](state: NFCState, items: NFCInformations[]) {
        state.NFC = [...state.NFC, ...items];
    },
    [NFC.RESET_ITEMS](state: NFCState) {
        state.NFC = [];
        state.page = 0;
        state.count = 0;
    },
    [NFC.ADD_NFC_FILTER_SITE](state: NFCState, site: Site) {
        state.filterSite = [...state.filterSite, site];
    },
    [NFC.REMOVE_NFC_FILTER_SITE](state, site: Site) {
        state.filterSite = state.filterSite.filter(x => x !== site);
    },
    [NFC.SET_NFC_FILTER_SITE](state: NFCState, siteList: Site[]) {
        state.filterSite = siteList;
    },
    [NFC.SET_FILTER_LOCALISATION](state: NFCState, value: string) {
        state.filterLocalisation = value;
    },
    [NFC.SET_PAGE](state: NFCState, page: number) {
        state.page = page;
    },
    [NFC.SET_NB_OF_PAGES](state: NFCState, pages: number) {
        state.nbOfPages = pages;
    },
    [NFC.SET_SCROLL](state: NFCState, scroll: number) {
        state.scroll = scroll;
    },
    [NFC.SET_COUNT](state: NFCState, count: number) {
        state.count = count;
    },
    [NFC.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return[...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [NFC.RESET](state){
        Object.assign(state, resetState);
    },
    [NFC.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [NFC.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [NFC.SET_HISTORIQUE](state: NFCState, items: NFCHistorique[]) {
        state.nfcHistorique = items;
    },
    [NFC.ADD_HISTORIQUE](state: NFCState, items: NFCHistorique[]) {
        state.nfcHistorique = [...state.nfcHistorique, ...items];
    },
    [NFC.SET_NUMERO_NFC](state: NFCState, numeroNFC: number) {
        state.numeroNFC = numeroNFC;
    },

    [NFC.SET_HISTORIQUE_SORT](
        state: NFCState,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.historiqueTableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return[...newTable, headerItem];
        }, [] as TableHeader[]);
        state.historiqueTableHeader = tableHeader;
        state.sortHistorique = sort;
    },
    [NFC.SET_NB_OF_HISTORIQUE_PAGES](state: NFCState, pages: number) {
        state.nbOfHistoriquePages = pages;
    },
    [NFC.SET_HISTORIQUE_SCROLL](state: NFCState, scroll: number) {
        state.historiqueScroll = scroll;
    },
    [NFC.SET_HISTORIQUE_PAGE](state: NFCState, page: number) {
        state.historiquePage = page;
    },
    [NFC.SET_HISTORIQUE_IS_LOADING](state: NFCState, isLoading: boolean) {
        state.isHistoriqueLoading = isLoading;
    },
    [NFC.ADD_ITEMS](state: NFCState, items: NFCInformations[]) {
        state.NFC = [...state.NFC, ...items];
    },
    [NFC.RESET_HISTORIQUE](state: NFCState) {
        state.nfcHistorique = [];
        state.page = 0;
    },
};
